import React, { memo } from 'react';
import { Container, Row, Col, Spinner, Alert, Badge, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Format price helper function
const formatPrice = (price) => {
  if (!price || price === 0) return 'Gratuit';
  // Remove decimal places and add thousands separator
  return parseInt(price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' DZD';
};

const EventsGrid = memo(({ 
  events, 
  loading, 
  error, 
  hasMore, 
  refreshing, 
  onLoadMore 
}) => {
  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" variant="danger" />
        <p className="mt-3">Chargement des événements...</p>
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="mb-3">
        <i className="fas fa-exclamation-circle me-2"></i>
        {error}
      </Alert>
    );
  }

  if (events.length === 0) {
    return (
      <Alert variant="info">
        <i className="fas fa-info-circle me-2"></i>
        Aucun événement ne correspond à vos critères de recherche.
      </Alert>
    );
  }

  return (
    <>
           
      <Row>
          {events.map(event => (
            <Col md={4} key={event.id} style = {{height: '100%',
                                                 transition: 'transform 0.3s ease'}}>
              <Card className="event-card h-100 shadow-sm">
                {event.image && (
                  <div className="event-image-container">
                    <Card.Img 
                      variant="top" 
                      src={event.image.startsWith('/media') 
                        ? `${event.image.replace('/media', '')}`
                        : `${event.image}`
                      } 
                      alt={event.title} 
                    />
                    {event.is_featured && (
                      <Badge bg="danger" className="featured-badge">
                        <i className="fas fa-star me-1"></i> À la une
                      </Badge>
                    )}
                  </div>
                )}
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <Card.Title>{event.title}</Card.Title>
                    {event.category && (
                      <Badge bg="primary" className="category-badge">
                        {event.category.icon && <i className={`${event.category.icon} me-1`}></i>}
                        {event.category.name}
                      </Badge>
                    )}
                  </div>
                  <div className="event-meta text-muted mb-3">
                    <div><i className="far fa-calendar-alt me-2"></i>{event.formatted_date}</div>
                    <div><i className="far fa-clock me-2"></i>{event.time}</div>
                    <div><i className="fas fa-map-marker-alt me-2"></i>{event.location}</div>
                    {event.wilaya_name && (
                      <div><i className="fas fa-map me-2"></i>{event.wilaya_name}</div>
                    )}
                    <div><i className="fas fa-building me-2"></i>{event.partner_name || "Delta Trae"}</div>
                  </div>
                  {/* <Card.Text>
                    {event.description && (event.description.length > 100 
                      ? `${event.description.substring(0, 100)}...` 
                      : event.description)}
                  </Card.Text> */}
                </Card.Body>
                <Card.Footer className="bg-white">
                  <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center">
                    <div className="event-price mb-2 mb-sm-0">
                      {event.price ? (
                        <span className="text-danger fw-bold">{formatPrice(event.price)}</span>
                      ) : (
                        <span className="text-success">Gratuit</span>
                      )}
                    </div>
                    <div className="button-group">
                      <Link to={`/event/${event.id}`} className="btn btn-outline-secondary  me-2">
                        <i className="fas fa-info-circle me-1"></i> Détails
                      </Link>
                      {/* <Link 
                        to={`/event/${event.id}/reservation`} 
                        className="btn btn-danger "
                        disabled={event.is_sold_out || event.registration_closed || event.is_past}
                      >
                        <i className="fas fa-ticket-alt me-1"></i> Réserver
                      </Link> */}
                    </div>
                  </div>
                </Card.Footer>
                {(event.is_sold_out || event.registration_closed || event.is_past) && (
                  <div className="event-overlay">
                    <span className="event-status">
                      {event.is_sold_out ? 'Complet' : event.is_past ? 'Terminé' : 'Inscriptions fermées'}
                    </span>
                  </div>
                )}
              </Card>
            </Col>
          ))}
        </Row>
      {/* Load more button */}
      {events.length > 0 && hasMore && (
        <div className="text-center mt-4">
          <Button 
            id="loadmorebtn"
            variant="danger" 
            onClick={onLoadMore}
            disabled={refreshing}
          >
            {refreshing ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Chargement...
              </>
            ) : (
              <>
                <i className="fas fa-plus-circle me-1"></i>
                Charger plus d'événements
              </>
            )}
          </Button>
        </div>
      )}
    </>
  );
});

export default EventsGrid;